<mat-divider class="tab-header"></mat-divider>
<div class="oi-peek-margin">
    <div class="oi-subheader-text tapestry-body body--sm">
        {{ 'client-core.global-nav.partner-support.description' | translate }}
    </div>
    <tapestry-inline-message-box
        [content]="'seller-tools-panel.oi-link.info-message' | translate"
        [type]="InlineMessageBoxType.Soft"
    ></tapestry-inline-message-box>
    <div class="oi-action-row">
        <tapestry-button
            [text]="'common.oi-link.create-link' | translate"
            icon="add"
            [size]="ButtonSize.Small"
            (buttonClicked)="addNewLinkButtonPressed()"
            [disabled]="addNewLink || !prospectFolder"
            submitType="button"
            trackingName="createOILinkBtn"
        ></tapestry-button>
        <tapestry-search
            class="oi-search-filter"
            [size]="SearchBoxSize.Small"
            [placeholder]="
                'seller-tools.oi-link.search-placeholder' | translate
            "
            (searchValueChanged)="onFilterTextChanged($event)"
            [enterPressClearsSearchText]="false"
        ></tapestry-search>
        <div class="view-assessments-link-container">
            <tapestry-icon name="close_panel"></tapestry-icon>
            <a (click)="viewAllAssessments()">
                {{ 'seller-tools.view-all-prospects' | translate }}</a
            >
        </div>
    </div>
    @if (addNewLink) {
        <form [formGroup]="oiForm" class="oi-link-details-container">
            <div class="form-control-container">
                <tapestry-text
                    formControlName="name"
                    [required]="true"
                    [label]="
                        'client-core.oi-notifications.controls.link-name.label'
                            | translate
                    "
                    [control]="oiForm.controls.name"
                ></tapestry-text>
                @if (
                    oiForm.controls.name.invalid &&
                    (oiForm.controls.name.dirty || oiForm.controls.name.touched)
                ) {
                    <div class="validation-error-text">
                        @if (oiForm.controls.name.errors?.pattern) {
                            {{
                                'client-core.oi-notifications.controls.link-name.validation.pattern'
                                    | translate
                            }}
                        }
                        @if (
                            oiForm.controls.name.errors?.required ||
                            oiForm.controls.name.errors?.notOnlyWhitespace !==
                                undefined
                        ) {
                            {{
                                'client-core.oi-notifications.controls.link-name.validation.required'
                                    | translate
                            }}
                        }
                        @if (oiForm.controls.name.errors?.maxlength) {
                            {{
                                'client-core.oi-notifications.controls.link-name.validation.max-length'
                                    | translate
                            }}
                        }
                    </div>
                }
            </div>
            <div class="form-control-container">
                <tapestry-text-area
                    formControlName="description"
                    [required]="true"
                    [label]="
                        'client-core.oi-notifications.controls.link-description.label'
                            | translate
                    "
                    [control]="oiForm.controls.description"
                    piTesting="oILinkDescription"
                ></tapestry-text-area>
                @if (
                    oiForm.controls.description.invalid &&
                    (oiForm.controls.description.dirty ||
                        oiForm.controls.description.touched)
                ) {
                    <div class="validation-error-text">
                        @if (
                            oiForm.controls.description.errors?.required ||
                            oiForm.controls.name.errors?.notOnlyWhitespace !==
                                undefined
                        ) {
                            {{
                                'client-core.oi-notifications.controls.link-description.validation.required'
                                    | translate
                            }}
                        }
                        @if (oiForm.controls.description.errors?.maxlength) {
                            {{
                                'client-core.oi-notifications.controls.link-description.validation.max-length'
                                    | translate
                            }}
                        }
                    </div>
                }
            </div>
            <tapestry-accordion class="oi-accordion-wrapper">
                <tapestry-expansion-panel-item>
                    <div title>
                        {{ 'common.notificationsettings' | translate }}
                    </div>
                    <div content class="oi-peek-notification-settings">
                        <tapestry-chip-select
                            formControlName="linkOwner"
                            [label]="
                                'client-core.oi-notifications.link-owner'
                                    | translate
                            "
                            [loading]="loadingLinkOwner"
                            [options]="linkOwnerOptions"
                            (filterChange)="linkOwnerFilterChange($event)"
                            required
                        ></tapestry-chip-select>
                        @if (
                            oiForm.controls.linkOwner.invalid &&
                            (oiForm.controls.linkOwner.dirty ||
                                oiForm.controls.linkOwner.touched)
                        ) {
                            <div
                                class="oi-peek-notification-settings-validation-error"
                            >
                                @if (
                                    oiForm.controls.linkOwner.errors
                                        ?.minLinkOwner
                                ) {
                                    <div>
                                        {{
                                            'client-core.oi-notifications.validation.link-owner.required'
                                                | translate
                                        }}
                                    </div>
                                }
                                @if (
                                    oiForm.controls.linkOwner.errors
                                        ?.maxLinkOwner
                                ) {
                                    <div>
                                        {{
                                            'client-core.oi-notifications.validation.link-owner.max-length'
                                                | translate
                                        }}
                                    </div>
                                }
                            </div>
                        }
                        <tapestry-multi-autocomplete
                            formControlName="stakeholders"
                            [label]="'common.stakeholders' | translate"
                            [separatorKeysCodes]="[SPACE, COMMA, SEMICOLON]"
                            [loading]="loadingStakeholders"
                            [autocompleteOptions]="stakeholderOptions"
                            (inputValueChange)="stakeholderFilterChange($event)"
                            [inputValueChangeDebounce]="500"
                        ></tapestry-multi-autocomplete>
                        @if (
                            oiForm.controls.stakeholders.invalid &&
                            (oiForm.controls.stakeholders.dirty ||
                                oiForm.controls.stakeholders.touched)
                        ) {
                            <div
                                class="oi-peek-notification-settings-validation-error"
                            >
                                @if (
                                    oiForm.controls.stakeholders.errors
                                        ?.invalidEmails
                                ) {
                                    <div>
                                        {{
                                            'client-core.oi-notifications.validation.stakeholders.invalid-email'
                                                | translate
                                        }}
                                    </div>
                                }
                                @if (
                                    oiForm.controls.stakeholders.errors
                                        ?.invalidDomains
                                ) {
                                    <div>
                                        {{
                                            'client-core.oi-notifications.validation.stakeholders.invalid-domain'
                                                | translate
                                        }}
                                    </div>
                                }
                                @if (
                                    oiForm.controls.stakeholders.errors
                                        ?.maxStakeholders
                                ) {
                                    <div>
                                        {{
                                            'client-core.oi-notifications.validation.stakeholders.max-length'
                                                | translate
                                        }}
                                    </div>
                                }
                            </div>
                        }
                        <oi-notifications-table
                            formControlName="notificationSettings"
                        ></oi-notifications-table>
                    </div>
                </tapestry-expansion-panel-item>
                <tapestry-expansion-panel-item>
                    <div title>
                        {{ 'assessmentcenter.additionalconfig' | translate }}
                    </div>
                    <div content>
                        <tapestry-select
                            [selectLabel]="'defaultoilanguage' | translate"
                            [selected]="selectedLanguage"
                            [placeholder]="selectedLanguage"
                            class="oi-link-config-container"
                            [options]="languageOptions"
                            [size]="SelectSize.Small"
                            [control]="oiForm.controls.language"
                            (selectChanged)="
                                oiForm.controls.language.setValue($event)
                            "
                        ></tapestry-select>
                        <div class="oi-link-config-container flex">
                            <tapestry-checkbox
                                [label]="
                                    'label.assessment.openinvitation.kioskmode'
                                        | translate
                                "
                                formControlName="kiosk"
                                [disabled]="
                                    !!(
                                        oiForm.controls.redirectURL.value ||
                                        currentEditLink?.redirectURL
                                    )
                                "
                                (checkChanged)="assessRedirectUrl($event)"
                            ></tapestry-checkbox>
                            <tapestry-icon
                                name="info"
                                tapestry-rich-text-tooltip
                                #tooltipOrigin="tapestry-rich-text-tooltip"
                                [tooltipContent]="kioskInfo"
                            ></tapestry-icon>
                            <tapestry-rich-text-tooltip-content
                                #kioskInfo
                                [tooltipOrigin]="tooltipOrigin"
                                [tooltipPosition]="TooltipPosition.Right"
                            >
                                <div
                                    class="rich-text-tooltip tooltip-dark oi-link-tooltip"
                                >
                                    {{
                                        'assessmentcenter.editoiinvitation-notifications-kiosk-tooltip'
                                            | translate
                                    }}
                                </div>
                            </tapestry-rich-text-tooltip-content>
                        </div>
                        <div class="oi-link-config-container flex">
                            <tapestry-text
                                [label]="'redirecturl' | translate"
                                [control]="oiForm.controls.redirectURL"
                                formControlName="redirectURL"
                                [errors]="
                                    uniqueUrlErrors.isNotUnique | translate
                                "
                            ></tapestry-text>
                            <tapestry-icon
                                name="info"
                                tapestry-rich-text-tooltip
                                #redirectTooltipOrigin="tapestry-rich-text-tooltip"
                                [tooltipContent]="redirectURLInfo"
                            ></tapestry-icon>
                            <tapestry-rich-text-tooltip-content
                                #redirectURLInfo
                                [tooltipOrigin]="redirectTooltipOrigin"
                                [tooltipPosition]="TooltipPosition.Right"
                            >
                                <div
                                    class="rich-text-tooltip tooltip-dark oi-link-tooltip"
                                >
                                    {{
                                        'assessmentCenter.editOiInvitation-notifications-redirect-tooltip'
                                            | translate
                                    }}
                                </div>
                            </tapestry-rich-text-tooltip-content>
                        </div>
                    </div>
                </tapestry-expansion-panel-item>
            </tapestry-accordion>
            <div class="oi-form-buttons">
                <tapestry-button
                    [text]="'text.common-terms.cancel' | translate"
                    [color]="buttonColor.Secondary"
                    (buttonClicked)="cancel()"
                    submitType="button"
                    trackingName="cancelOILinkBtn"
                ></tapestry-button>
                <tapestry-button
                    [text]="'common.save' | translate"
                    (buttonClicked)="createOILink()"
                    [disabled]="isSubmitting || oiForm.invalid"
                    trackingName="saveOILinkBtn"
                ></tapestry-button>
            </div>
        </form>
    }
    <tapestry-grid
        #oiGrid
        class="ag-theme-tapestry-grid ag-grid-wrapper seller-tools-grid oi-grid-margin"
        [rowData]="oiDataSource"
        [columnDefs]="columnDefs"
        [frameworkComponents]="components"
        [useAutoHeight]="false"
        (gridReady)="onGridReady($event)"
    ></tapestry-grid>
</div>
